var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProcessSubProcessTaskIcon = function SvgProcessSubProcessTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#595959",
    viewBox: "0 0 24 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.628 8.837v.32h-.641a.32.32 0 0 0-.275.486l.962 1.602a.32.32 0 0 0 .549 0l.961-1.602a.32.32 0 0 0-.274-.486h-.641v-.32a2.246 2.246 0 0 0-2.243-2.243H10.18a2.246 2.246 0 0 0-2.243 2.243h.64c0-.883.72-1.602 1.603-1.602h3.845c.883 0 1.602.719 1.602 1.602M8.62 13.047v-.32h.64a.32.32 0 0 0 .275-.486l-.962-1.602a.32.32 0 0 0-.549 0l-.961 1.602a.32.32 0 0 0 .275.486h.64v.32a2.246 2.246 0 0 0 2.243 2.243h3.846a2.246 2.246 0 0 0 2.243-2.243h-.641c0 .884-.719 1.602-1.602 1.602H10.22a1.604 1.604 0 0 1-1.602-1.602"
  })));
};
var Memo = /*#__PURE__*/memo(SvgProcessSubProcessTaskIcon);
export default Memo;